import YesNoNumberInput from './YesNoNumberInput';
export default YesNoNumberInput;